import {useRef, useState, useEffect} from 'react';
import {toast, Toaster} from 'react-hot-toast';
import axios from "../../api/axiosClient";
import { Box, Button, Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel, Grid, IconButton, Input, Modal, Radio, RadioGroup, Typography } from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";
import PageHeader from '../../components/ui/PageHeader';
import PageForm from '../../components/ui/PageForm';
import CustomInput from '../../components/ui/CustomInput';

import { useSelector, useDispatch } from 'react-redux';
import { Navigate, useNavigate } from 'react-router-dom';
import CustomTable from '../../components/ui/CustomTable';
import CustomGridCell from '../../components/ui/CustomGridCell';
import CustomGridHeaderCell from '../../components/ui/CustomGridHeaderCell';
import { useIntl} from 'react-intl';
import { getFile, addDownloadLinkToDocument, handleError, errorToast } from '../../services/serviceBase';
import { useLoading } from "../../components/LoadingContext";
import CustomTriStateCheckbox from '../../components/ui/CustomTriSateCheckbox';

const CSVFromLWH = (props) => {
    const intl = useIntl();
    const { setLoading } = useLoading();

    const [lwhSenders, setLwhSenders] = useState([]);
    const [sendersDropDown, setSendersDropDown] = useState([]);
    const [senderLwhJdaLocation, setSenderLwhJdaLocation] = useState('');
    const [senderLwhIdJdaLocation, setSenderLwhIdJdaLocation] = useState(0);
    const [senderLwhJdaEnv, setSenderLwhJdaEnv] = useState('');
    const [destinations, setDestinations] = useState([]);
    const [destinationsDropDown, setDestinationsDropDown] = useState([]);
    const [destination, setDestination] = useState('');
    const [withQty, setWithQty] = useState(false);

    const [isDamaged, setIsDamaged] = useState(false);
    const [isRebalancing, setIsRebalancing] = useState(false);
    const [salePrice, setSalePrice] = useState('MarkDown');
    const [fullQty, setFullQty] = useState('full');
    const [totPcs, setTotPcs] = useState(null);

    const [tableHeigth, setTableHeigth] = useState(450);
    const [csvRows, setCsvRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [showCSVGrid, setShowCSVGrid] = useState(false);
    const [exportKey, setExportKey] = useState('');

    const customerCode = useSelector((state) => state.actas.customerCode);
    const jdaLocationCode = useSelector((state) => state.actas.jdaLocationCode);
    const shopCode = useSelector((state) => state.actas.shopCode);
    const idCompany = useSelector((state) => state.common.company);
    var navigate = useNavigate();

    useEffect(() => {
        setLwhSenders([]);
        setSendersDropDown([]);
        setSenderLwhJdaLocation('');
        setSenderLwhIdJdaLocation(0);
        setSenderLwhJdaEnv('');
        setDestinations([]);
        setDestination('');
        setDestinationsDropDown([]);
        setDestination('');
        setWithQty(false);
        setIsDamaged(false);
        setIsRebalancing(false);
        setSalePrice('MarkDown');
        setFullQty('full');
        getLWHSenders();
        setShowCSVGrid(false);
        setExportKey('');
        setCsvRows([]);
    }, [props.isTriangulation]);

    const getLWHSenders = async () => {
        setLoading(true);
        const params = new URLSearchParams([]);

        const jdaLocationParam = jdaLocationCode != null ? jdaLocationCode : "";

        params.append('CustomerCode', customerCode)
        params.append('JdaLocation', jdaLocationParam)

        axios.get('/csvFromLocalWarehouse/GetLWHSenders', {params})
        .then((response) => {
            setLoading(false);
            var selectSenderItems = [];
            if(response.data !== undefined){
                response.data.map((x) => {
                    selectSenderItems.push({value: x.jdaLocation, text: `${x.jdaLocation}`+' - '+`${x.description}` });
                });
            }
            setLwhSenders(response.data);
            setSendersDropDown(selectSenderItems);

            if(selectSenderItems.length == 1){
                var senderItem = response.data.find(x => x.jdaLocation == selectSenderItems[0].value);
                if(senderItem !== null && senderItem !== undefined){
                    setSenderLwhJdaLocation(senderItem.jdaLocation);
                    setSenderLwhIdJdaLocation(senderItem.idJDALocation);
                    setSenderLwhJdaEnv(senderItem.idJDAEnvironment);
                }
            }
        })
        .catch((error) => {
            setLoading(false);
            handleError(error, intl);
        })
    }

    const getLWHDestinations = async () => {
        setLoading(true);
        var salePriceType = salePrice;
        var url = '';
        const params = new URLSearchParams([]);
        if(props.isTriangulation){
            params.append('idJDALocationSender', senderLwhIdJdaLocation);
            params.append('salePriceType', salePriceType);
            url = '/csvFromLocalWarehouse/GetTriangulationDestinations';
        }
        else{
            params.append('idEnvirormentOfJDALocationSender', senderLwhJdaEnv);
            params.append('salePriceType', salePriceType);
            params.append('isDamaged', isDamaged);
            params.append('isTriangulation', props.isTriangulation);
            params.append('isRebalancing', isRebalancing);
            url = '/csvFromLocalWarehouse/GetLWHDestinations';
        }

        axios.get(url, {params})
            .then((response) => {
                setLoading(false);
                var selectDestinationItems = [];
                if(response.data !== undefined){
                    response.data.map((x) => {
                        selectDestinationItems.push({value: x.idJDALocation, text: `${x.jdaLocation}`+' - '+`${x.description}` });
                    });
                }
                setDestinations(response.data);
                if(selectDestinationItems.length == 1){
                    setDestination(selectDestinationItems[0].value)
                }
                setDestinationsDropDown(selectDestinationItems);
            })
            .catch((error) => {
                setLoading(false);
                handleError(error, intl);
            })
    }

    useEffect(() => {
        if(customerCode == null || customerCode == undefined || customerCode == ''){
            toast.error(intl.formatMessage({ id: "RACreation.NoActAs" }));
            navigate(`${process.env.PUBLIC_URL}/ActAs`);
            return;
        }

        getLWHSenders();
    }, []);
 
    const handleIsDamageChange = () => {
        setIsDamaged(!isDamaged);
        setIsRebalancing(false);
    }

    const handleIsRebalancingChange = () => {
        setIsDamaged(false);
        setIsRebalancing(!isRebalancing);
    }

    const handleSalePriceChange = (e) => {
        setSalePrice(e.currentTarget.value);
    }

    const handleWithQty = (e) => {
        var value = e.currentTarget.value;
        if(value=="full"){
            setWithQty(false);
        }
        if(value=='qty'){
            setWithQty(true);
        }
        setFullQty(value);
    }

    const handleSenderChange = (sender) => {
        var senderItem = lwhSenders.find(x => x.jdaLocation == sender);
        if(senderItem !== null && senderItem !== undefined){
            setSenderLwhJdaLocation(senderItem.jdaLocation);
            setSenderLwhIdJdaLocation(senderItem.idJDALocation);
            setSenderLwhJdaEnv(senderItem.idJDAEnvironment);
        }
    }

    const resizeTable = () => {
        var fromHeight = document.querySelector('#form').clientHeight;
        var headerHeight = document.querySelector('#header').clientHeight;
        var pageHeight = window.innerHeight;
        var tableHeight = pageHeight -  fromHeight - headerHeight - 120;
        setTableHeigth(tableHeight);
    }

    useEffect(() => {
      window.addEventListener("resize", resizeTable);
      return () => {
        window.removeEventListener("resize", resizeTable);
      };
    }, []);

    useEffect(() => {
        getColumns();
    }, [csvRows, tableHeigth]);

    const getColumns = () => {
        setColumns(
        [
            {
                field: 'sourceWarehouse',
                headerClassName: 'grid-header apeLigthBlueBackground',
                renderHeader: () => (
                    <CustomGridHeaderCell item1={intl.formatMessage({ id: "RACreation.SenderLWH" })}/>
                  ),
                flex: 1,
                minWidth:20,
            },
            {
                field: 'destinationWarehouse',
                renderHeader: () => (
                    <CustomGridHeaderCell item1={intl.formatMessage({ id: "RACreation.DestinationCWH" })} />
                  ),
                headerClassName: 'grid-header apeLigthBlueBackground',
                flex: 1,
                minWidth:20,
            },
            {
                field: 'affinityGroup',
                renderHeader: () => (
                    <CustomGridHeaderCell item1={intl.formatMessage({ id: "General.AffinityGroup" })}/>
                  ),
                headerClassName: 'grid-header apeLigthBlueBackground',
                flex: 1,
                minWidth:100,
            },
            {
                field: 'fileName',
                renderHeader: () => (
                    <CustomGridHeaderCell item1={intl.formatMessage({ id: "RACreation.CSVName" })}/>
                  ),
                headerClassName: 'grid-header apeLigthBlueBackground',
                flex: 1,
                minWidth: 550,
            },
            {
                field: 'formattedReturnFileKey',
                renderHeader: () => (
                    <CustomGridHeaderCell item1={intl.formatMessage({ id: "RA.Key" })}/>
                  ),
                headerClassName: 'grid-header apeLigthBlueBackground',
                flex: 1,
                minWidth: 200,
            },
        ]
        );
    }

    useEffect(() => {
        if(senderLwhJdaLocation !== ''){
            getLWHDestinations();
        }
    }, [senderLwhJdaLocation, isDamaged, isRebalancing, salePrice]);

    const handleGenerateCSV = () => {
        setLoading(true);
        const params = new URLSearchParams([]);
        params.append('idCompany', idCompany);

        var senderItem = lwhSenders.find(x => x.jdaLocation == senderLwhJdaLocation);
        if(senderItem !== null && senderItem !== undefined){
            params.append('idJDALocationSender', senderItem.idJDALocation);
        }

        var destinationItem = destinations.find(x => x.idJDALocation == destination);
        if(destinationItem !== null && destinationItem !== undefined){
            params.append('idJDALocationDestination', destinationItem.idJDALocation);
        }

        var salePriceType = salePrice;
        params.append('discriminant', salePriceType);
        params.append('withQty', withQty);
        params.append('isDamaged', isDamaged);
        params.append('isTriangulation', props.isTriangulation);

        if(totPcs !== undefined && totPcs !== '' && totPcs != null){
            params.append('maxPcsInCSV', `${totPcs}`);
        }
        
        var url = '/csvFromLocalWarehouse/GenerateCSV'+'?'+params.toString();

        axios
          .post(url)
          .then((response) => {

            setLoading(false);
            if (response.data != null && response.data != undefined) {
              handleCSVResponseWarnings(response.data);

              setExportKey(response.data.exportKey);
              setCsvRows(response.data.csvResultItems);
              setShowCSVGrid(true);
            }
          })
          .catch((error) => {
            setLoading(false);
            if (error?.response?.data?.type == "NoJDAStockFound") {
              toast.error(
                intl.formatMessage({ id: "Error.NoJDAStockFoundCSV" })
              );
            } else {
              handleError(error, intl);
            }
          });
    }

     const handleCSVResponseWarnings = (responseData) => {
       if (
         responseData.affinityGroupsNotEnabled &&
         responseData.affinityGroupsNotEnabled.length > 0
       ) {
         toast(
           (t) => (
             <div style={{ display: "flex", alignItems: "start", gap: 8 }}>
               <WarningIcon size="large" />
               <div>
                 {intl.formatMessage({ id: "Error.AffinityGroupsNotEnabled" })}: {responseData.affinityGroupsNotEnabled.join()}
               </div>
               <button
                 onClick={() => toast.dismiss(t.id)}
                 aria-label="Chiudi"
                 style={{
                   background: "transparent",
                   border: 0,
                   cursor: "pointer",
                 }}
               >
                 ✕
               </button>
             </div>
           ),
           { duration: Infinity },
         );
       }

       var message;
       if (
         responseData.packagingErrors &&
         responseData.packagingErrors.length > 0
       ) {
         responseData.packagingErrors.forEach((element) => {
           if (element == "CountryNotConfigured") {
             message = intl.formatMessage({ id: "Error.CountryNotConfigured" });
           } else if (element == "NoDestinationsEnabled") {
             message = intl.formatMessage({
               id: "Error.NoDestinationsEnabled",
             });
           } else {
             message = intl.formatMessage({ id: "Error.MultipleDestinations" });
           }
         });
         toast(
           (t) => (
             <div style={{ display: "flex", alignItems: "start", gap: 8 }}>
               <WarningIcon size="large" />
               <div>{message}</div>
               <button
                 onClick={() => toast.dismiss(t.id)}
                 aria-label="Chiudi"
                 style={{
                   background: "transparent",
                   border: 0,
                   cursor: "pointer",
                 }}
               >
                 ✕
               </button>
             </div>
           ),
           { duration: Infinity },
         );
       }
     };

    useEffect(() => {
      if (exportKey !== "") {
        downloadCSVZip();
      }
    }, [exportKey]);

    const downloadCSVZip = () => {
        setLoading(true);
        const params = new URLSearchParams([]);
        params.append('exportKey', exportKey);
        var url = '/csvFromLocalWarehouse/GetCSVZip'+'?'+params.toString();
        getFile(url, (response) => {
            setLoading(false);
            var filename = response.name;
            addDownloadLinkToDocument(response, "application/octet-stream", filename);
        }, (error) => {
            setLoading(false);
            handleError(error, intl);
        }, null);
    }

    return (
        <Box sx={{overflow: 'hidden'}}>
            <PageHeader title={props.isTriangulation ? intl.formatMessage({ id: "RACreation.TriangulationLWH" }): intl.formatMessage({ id: "RACreation.FromLWH" })}/>
            <form id="form">
            <Grid container >
               <Grid item md={4} >
                    <CustomInput color='blue' labelText={intl.formatMessage({ id: "RACreation.SenderLWH" })} type="select" textCol={3} inputCol={8} valueRef={senderLwhJdaLocation} selectItems={sendersDropDown} setValue={handleSenderChange}/>
               </Grid>
               <Grid item md={4} >
                   <CustomInput color='blue' labelText={intl.formatMessage({ id: "RACreation.DestinationCWH" })} type="select" textCol={4} inputCol={8} valueRef={destination} selectItems={destinationsDropDown} setValue={setDestination} selectFirst={true}/>
               </Grid>
               <Grid item md={4} >
                    <CustomInput color='blue' labelText={intl.formatMessage({ id: "RACreation.TotPCSInCSV" })} type="number" value={totPcs} setValue={setTotPcs} textCol={3} inputCol={6}/>
               </Grid>
            </Grid>
            <Grid container>
                <Grid item md={1}></Grid>
                <Grid item md={3} >
                    <FormControl >
                        <RadioGroup
                                aria-labelledby="salePrice-radio-buttons-group-label"
                                defaultValue='MarkDown'
                                name="radio-buttons-group"
                                sx={{border:2, borderColor: '#85ABD5', borderRadius:'15px', paddingRight:'15px' }}
                                onChange={handleSalePriceChange}
                        >
                            <FormControlLabel value="MarkDown" control={<Radio />} label={<Typography sx={{fontSize:12}} >{intl.formatMessage({ id: "General.MarkDown" })}</Typography>} labelPlacement='start' />
                            <FormControlLabel value="FullPrice" control={<Radio />} label={<Typography sx={{fontSize:12}} >{intl.formatMessage({ id: "General.FullPrice" })}</Typography>} labelPlacement='start' />
                        </RadioGroup>
                    </FormControl>
                </Grid>
                <Grid item md={1}></Grid>
                
                <Grid item md={3}>
                    <FormControl style={props.isTriangulation ? { display: 'none' } : {}}>
                        <FormGroup sx={{border:2, borderColor: '#85ABD5', borderRadius:'15px', paddingRight:'15px' }}>
                            <FormControlLabel control={<Checkbox checked={isRebalancing} onChange={handleIsRebalancingChange} />} label={<Typography sx={{fontSize:12}} >{intl.formatMessage({ id: "General.Rebalancing" })}</Typography>} labelPlacement='start'/>
                            <FormControlLabel control={<Checkbox checked={isDamaged} onChange={handleIsDamageChange}/>} label={<Typography sx={{fontSize:12}} >{intl.formatMessage({ id: "General.Damaged" })}</Typography>} labelPlacement='start' />
                        </FormGroup>
                    </FormControl>
                </Grid>

                <Grid item md={1}></Grid>
                <Grid item md={3} >
                    <FormControl >
                        <RadioGroup
                                aria-labelledby="qty-radio-buttons-group-label"
                                defaultValue='full'
                                name="radio-buttons-group"
                                sx={{border:2, borderColor: '#85ABD5', borderRadius:'15px', paddingRight:'15px' }}
                                onChange={handleWithQty}
                        >
                            <FormControlLabel value="full" control={<Radio />} label={<Typography sx={{fontSize:12}} >{intl.formatMessage({ id: "RACreation.CSVFullStock" })}</Typography>} labelPlacement='start'  />
                            <FormControlLabel value="qty" control={<Radio />} label={<Typography sx={{fontSize:12}} >{intl.formatMessage({ id: "RACreation.CSVSKUQty" })}</Typography>} labelPlacement='start' />
                        </RadioGroup>
                    </FormControl>
                </Grid>
            </Grid>
            <Grid container sx={{mt:2}}>
                <Grid item md={10} >
                </Grid>
                <Grid item md={1.5} display="flex" justifyContent="flex-end">
                    <Button variant="contained" sx={{width:'100%'}} className='apeLigthBlueBackground' onClick={handleGenerateCSV}>{intl.formatMessage({ id: "General.Generate" })}</Button>
                </Grid>
            </Grid>
            </form>
            
            {
                showCSVGrid ? 
                <Box sx={{mt:3}}>
                    <CustomTable  columns={columns} rows={csvRows} id={'formattedReturnFileKey'} rowHeight={50} headerHeight={30} tableHeight={tableHeigth}/>
                </Box>
                :
                ""
            }
            
        </Box>
    )
}

export default CSVFromLWH;